import { Component } from '@verndale/core';
import Swiper from 'swiper/js/swiper';
import { constEvent } from '../utils/constants';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $slider: this.el._$('.swiper-container')
    };
    this.swiper = null;
    this.dataInterval = this.el.getAttribute('data-slider-interval');
    this.sliderInterval = {
      delay: 5000,
      disableOnInteraction: false,
      stopOnLastSlide: true
    };

    this.isEditing = this.dom.$el.classList.contains('is-editing');

    if (this.dataInterval) {
      if (parseInt(this.dataInterval) === 0) {
        this.sliderInterval = false;
      } else {
        this.sliderInterval = {
          delay: parseInt(this.dataInterval) * 1000,
          disableOnInteraction: false,
          stopOnLastSlide: true
        };
      }
    }

    this.initSlider();
  }

  addListeners() {
    const { $slider } = this.dom;

    $slider._on('mouseover', this.pause.bind(this));
    $slider._on('mouseout', this.play.bind(this));

    document._on(constEvent.VIDEO_MODAL_OPENED, () => {
      this.modalOpened = true;
      this.pause();
    });
    document._on(constEvent.VIDEO_MODAL_CLOSED, () => {
      this.modalOpened = false;
      this.play();
    });
  }

  initSlider() {
    const { $slider } = this.dom;

    this.swiper = new Swiper($slider, {
      autoplay: this.sliderInterval,
      loop: true,
      allowTouchMove: !this.isEditing,

      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },

      navigation: {
        nextEl: '.swiper-arrow-next',
        prevEl: '.swiper-arrow-prev'
      }
    });

    this.updateTheme();
    this.swiper.on('slideChange', this.updateTheme.bind(this));
  }

  updateTheme() {
    const { $slider } = this.dom;

    const index = this.swiper?.realIndex || 0;
    const el = $slider?._$$('.hero-slider__slide');
    const currentSlide = el[index];
    const theme = currentSlide?.dataset?.theme || null;

    if (theme) this.el.dataset.theme = theme;
  }

  pause() {
    if (this.sliderInterval) {
      this.swiper.autoplay.stop();
    }
  }

  play() {
    if (this.sliderInterval && !this.modalOpened) {
      this.swiper.autoplay.start();
    }
  }
}

export default Module;
